import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {of} from 'rxjs';


@Injectable({
    providedIn: "root"
})
export class FiltersForGridService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache",
            "Expires": "Sat, 01 Jan 2000 00:00:00 GMT"
        })
    };

    constructor(private _http: HttpClient) {}

    getPresetFilters(filterGridType: string) {
        return this._http.get("/irebalone/filter/" + filterGridType, this.httpOptions);

        // false && console.log(filterGridType);
        // const listOfFilters = {
        //     "responseStatus": "SUCCESS",
        //     "responseData":[
        //         {filterName: 'Tran Type BUY', filterId: 1, default: false, system: false, filterModel: {"transactionType":{"values":["Buy"],"filterType":"set"}}},
        //         {filterName: 'Account 937000115', filterId: 2, default: false, system: false, filterModel: {"accountNumber":{"filterType":"text","type":"contains","filter":"937000115"}}},
        //         {filterName: 'Created Date Quarter 123456789', filterId: 3, default: false, system: false, filterModel: {"createdDate":{"filterType":"IrbAgDateColumnFilter","filterFrom":"2021-07-24","filterTo":"2021-10-21","type":"inRange","isArchive":false}}},
        //         {filterName: '3Tran Type BUY', filterId: 4, default: true, system: false, filterModel: {"transactionType":{"values":["Buy"],"filterType":"set"}}},
        //         {filterName: '4Account 937000115', filterId: 5, default: false, system: false, filterModel: {"accountNumber":{"filterType":"text","type":"contains","filter":"937000115"}}},
        //         {filterName: '5Tran Type BUY', filterId: 1, default: false, system: false, filterModel: {"transactionType":{"values":["Buy"],"filterType":"set"}}},
        //         {filterName: '6Account 937000115', filterId: 6, default: false, system: false, filterModel: {"accountNumber":{"filterType":"text","type":"contains","filter":"937000115"}}},
        //         {filterName: '7Tran Type BUY', filterId: 7, default: false, system: false, filterModel: {"transactionType":{"values":["Buy"],"filterType":"set"}}},
        //         {filterName: '8Account 937000115', filterId: 8, default: false, system: false, filterModel: {"accountNumber":{"filterType":"text","type":"contains","filter":"937000115"}}},
        //         {filterName: '9Tran Type BUY', filterId: 9, default: false, system: false, filterModel: {"transactionType":{"values":["Buy"],"filterType":"set"}}}
        // ]};
        // return of(listOfFilters)
    }

    updatePresetFilters(filter: any, filterGridType: string) {
        let filterPost: any = JSON.parse(JSON.stringify(filter));
        filterPost.filterModel = JSON.stringify(filterPost.filterModel);
        return this._http.post("/irebalone/filter/" + filterGridType, filterPost, this.httpOptions);
    }

    deletePresetFilter(filterId: number, filterGridType: string) {
        let url = 'irebalone/filter/delete/' + filterGridType + '/' + filterId;
        return this._http.get(url, this.httpOptions);
    }

    /*
    Possible DB structure

    user
    filterGridType (orderblotteractive, orderblotterclosed, models, portfolios...)
    filterName: 'No filter selected',
    filterId: -1,
    default: false,
    system: false,
    filterModel: {}

1. URL  - > http://irebalentone.cfdev01-tx-a.iteclientsys.local/irebalone/filter/{orderblotteractive}
Http Method ->  POST
Request ->
{"filterName":"Tran Type BUY 11381","default":true,"system":false,"filterModel":"{\"transactionType\":{\"values\":[\"Buy\"],\"filterType\":\"set\"}}"}
Response ->
{
    "responseStatus": "SUCCESS",
    "responseData": {
        "filterName": "Tran Type BUY 11381",
        "filterId": 338665200,
        "filterModel": "{\"transactionType\":{\"values\":[\"Buy\"],\"filterType\":\"set\"}}",
        "gridType": "orderblotteractive",
        "default": true,
        "system": false
    },
    "responseUtilityMap": null
}

2)  URL  -  http://irebalentone.cfdev01-tx-a.iteclientsys.local/irebalone/filter/{orderblotteractive}
Http Method -> GET

Response ->
{
    "responseStatus": "SUCCESS",
    "responseData": [
        {
            "filterName": "Tran Type BUY 3333",
            "filterId": 338665702,
            "filterModel": "{\"transactionType\":{\"values\":[\"sellandbuy\"],\"filterType\":\"new1new\"}}",
            "gridType": "orderblotteractive",
            "default": true,
            "system": false
        },
        {
            "filterName": "Tran Type BUY 11381",
            "filterId": 338665101,
            "filterModel": "{\"transactionType\":{\"values\":[\"Buy\"],\"filterType\":\"set\"}}",
            "gridType": "orderblotteractive",
            "default": false,
            "system": false
        }
    ],
    "responseUtilityMap": null
}

3) URL - http://irebalentone.cfdev01-tx-a.iteclientsys.local/irebalone/filter/delete/{gridType}/{filterId}
Http Method  -> GET
Response ->
{
    "responseStatus": "SUCCESS",
    "responseData": {
        "filterName": "Tran Type BUY 11381",
        "filterId": 338665100,
        "filterModel": "{\"transactionType\":{\"values\":[\"Buy\"],\"filterType\":\"set\"}}",
        "gridType": "orderblotteractive",
        "default": false,
        "system": false
    },
    "responseUtilityMap": null
}
     */
}
